import React from 'react';

export const NoResults = () => <section> No results!</section>;
